const steps = [
    {
        number: "01",
        title: "Define Your Rules",
        description: "Use our visual builder or AI chat to create entry/exit conditions based on technical indicators, price action, or fundamental data.",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
        )
    },
    {
        number: "02",
        title: "Backtest & Optimize",
        description: "Run your strategy against years of historical NSE/BSE data. Fine-tune parameters and understand risk metrics before going live.",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
        )
    },
    {
        number: "03",
        title: "Deploy & Monitor",
        description: "Connect your broker account and deploy your strategy. Monitor performance in real-time with comprehensive dashboards and alerts.",
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
        )
    }
];

const HowItWorksSection = ({ className = "" }) => {
    return (
        <section className={`py-24 px-4 md:px-12 lg:px-20 bg-base-200/50 ${className}`}>
            <div className="max-w-6xl mx-auto">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <span className="text-sm font-semibold text-primary uppercase tracking-wider">How It Works</span>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mt-3 mb-4">
                        <span className="text-base-content">From Idea to </span>
                        <span className="text-gradient">Execution</span>
                    </h2>
                    <p className="text-base-content/60 max-w-2xl mx-auto text-lg">
                        Build and deploy your trading strategy in three simple steps
                    </p>
                </div>

                {/* Steps */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
                    {/* Connecting line (desktop only) */}
                    <div className="hidden md:block absolute top-24 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-primary/20 via-primary/50 to-primary/20" />

                    {steps.map((step, index) => (
                        <div key={index} className="relative">
                            {/* Step Card */}
                            <div className="bg-base-100 rounded-2xl p-8 shadow-lg border border-base-300/50 h-full">
                                {/* Number badge */}
                                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary text-primary-content font-bold text-xl font-heading mb-6 shadow-lg shadow-primary/30">
                                    {step.number}
                                </div>

                                {/* Content */}
                                <h3 className="text-xl font-bold font-heading text-base-content mb-3 flex items-center gap-2">
                                    {step.title}
                                    <span className="text-primary">{step.icon}</span>
                                </h3>
                                <p className="text-base-content/60 leading-relaxed">
                                    {step.description}
                                </p>
                            </div>

                            {/* Arrow connector (mobile only) */}
                            {index < steps.length - 1 && (
                                <div className="flex justify-center my-4 md:hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
